import { render, staticRenderFns } from "./yzm.vue?vue&type=template&id=3883a614&scoped=true&"
import script from "./yzm.vue?vue&type=script&lang=js&"
export * from "./yzm.vue?vue&type=script&lang=js&"
import style0 from "./yzm.vue?vue&type=style&index=0&id=3883a614&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883a614",
  null
  
)

export default component.exports